import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderState',
  standalone: false
})
export class OrderStatePipe implements PipeTransform {

  // Mapa de estados a colores
  private colorGroups = {
    'subtle-grey': ['Draft'],
    'subtle-amber': ['Issued', 'Reviewed'],
    // SOU-481: con el flujo nuevo el recorrido acaba en 'Sent' y con el antiguo en
    // 'Approved'. Los dos van en verde para no marcar como pendiente una orden ya cerrada.
    'subtle-green': ['Approved', 'Sent', 'RomE', 'Invoiced', 'Paid'],
    'subtle-red': ['Rejected', 'Overdue']
  };

  // Lista completa de estados, en el orden del flujo (SOU-481)
  private statusList = [
    { label: 'Borrador', enum: 'Draft' },
    { label: 'Emitido', enum: 'Issued' },
    { label: 'Revisado', enum: 'Reviewed' },
    { label: 'Aprobado', enum: 'Approved' },
    { label: 'Enviado', enum: 'Sent' },
    { label: 'RomE', enum: 'RomE' },
    { label: 'Facturado', enum: 'Invoiced' },
    { label: 'Cobrado', enum: 'Paid' },
    { label: 'Rechazado', enum: 'Rejected' },
    { label: 'Vencido', enum: 'Overdue' },
  ];

  // Mapa rápido para búsquedas
  private statusMap = new Map<string, { label: string, color: string }>();

  constructor() {
    this.buildMaps();
  }

  private buildMaps(): void {
    // Crear mapa de colores
    const colorMap = new Map<string, string>();
    Object.entries(this.colorGroups).forEach(([color, enums]) => {
      enums.forEach(e => colorMap.set(e, color));
    });

    // Combinar datos
    this.statusList.forEach(item => {
      this.statusMap.set(item.enum, {
        label: item.label,
        color: colorMap.get(item.enum) || 'gris' // Default si no encuentra
      });
    });
  }

  transform(value: string): { label: string; class: string } {
    const defaultResult = { label: 'Desconocido', class: 'subtle-grey' };

    if (!value || !this.statusMap.has(value)) return defaultResult;

    const status = this.statusMap.get(value)!;
    return {
      label: status.label,
      class: status.color
    };
  }

}
